import { SVGLens } from "@/lib/svg";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
`;

export const Label = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 400;
  font-size: 1.25rem;
`;

export const Icon = styled(SVGLens)`
  width: 1rem;
  position: relative;
  top: 0.1rem;
`;
